import Login from "../modules/Login";

function LoginPage() {
  return <Login />;
}

export default LoginPage;
